// @flow
export type TransformConfig = {
  crop?: string,
  default_image?: string,
  format?: string,
  fetch_format?: string,
  flags?: string | Array<string>,
  width?: 'auto' | number,
  height?: number,
  quality?: 'auto' | number,
  background?: string,
};
type TransformName = $Keys<TransformConfig>;

const TransformParameterByName: { [TransformName]: string } = {
  crop: 'c_',
  default_image: 'd_',
  format: 'f_',
  fetch_format: 'f_',
  flags: 'fl_',
  width: 'w_',
  height: 'h_',
  quality: 'q_',
  background: 'b_',
};

export function mapConfigValueToTransformValue(
  name: string,
  value: number | string | Array<string>
): string {
  return Array.isArray(value) ? name + value.join('.') : name + value;
}

export function mapConfigToTransform(config: TransformConfig): string {
  const p = [];

  Object.keys(config).forEach(configKey => {
    const parameterName = TransformParameterByName[configKey];
    const configValue = config[configKey];

    if (parameterName && configValue) {
      p.push(mapConfigValueToTransformValue(parameterName, configValue));
    }
  });

  return p.sort().join(',');
}



// WEBPACK FOOTER //
// ./src/lib/pwr-cloudinary/Transform.js